import { type ActionType, createAction } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines.js';
import type { UploadFile } from './api.js';

export type UploadAssetsMeta = {
  callback?: (uploads: UploadFile[]) => void;
};

export const uploadAssets = createRoutine('assetUploader/UPLOAD_ASSETS')<
  UploadAssetsMeta,
  File[],
  undefined,
  UploadFile[],
  string,
  undefined
>();

export function requestAssetsUpload(files: File[]): ActionType<typeof uploadAssets.requested> {
  return uploadAssets.requested(files, {});
}

export type UploadAssetMeta = {
  filename: string;
};

export const uploadAsset = createRoutine('assetUploader/UPLOAD_ASSET')<
  UploadAssetMeta,
  undefined,
  undefined,
  undefined,
  string,
  undefined
>();

export type ReplaceAssetMeta = {
  assetId: string;
  assetVersion: number;
};

export const replaceAsset = createRoutine('assetUploader/REPLACE_ASSET')<
  ReplaceAssetMeta,
  File,
  undefined,
  File,
  string,
  undefined
>();

export type UploadProgressPayload = {
  progress: number;
  filename: string;
};

export const uploadAssetProgress = createAction('assetUploader/UPLOAD_ASSET_PROGRESS')<UploadProgressPayload>();

export type Actions =
  | ActionType<typeof uploadAssets>
  | ActionType<typeof uploadAsset>
  | ActionType<typeof replaceAsset>
  | ActionType<typeof uploadAssetProgress>;
